import { render, staticRenderFns } from "./TechnicalSpecs.vue?vue&type=template&id=030671cb&scoped=true"
import script from "./TechnicalSpecs.vue?vue&type=script&lang=js"
export * from "./TechnicalSpecs.vue?vue&type=script&lang=js"
import style0 from "./TechnicalSpecs.vue?vue&type=style&index=0&id=030671cb&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "030671cb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\Generac.Application.MobileLink\\ClientApp\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('030671cb')) {
      api.createRecord('030671cb', component.options)
    } else {
      api.reload('030671cb', component.options)
    }
    module.hot.accept("./TechnicalSpecs.vue?vue&type=template&id=030671cb&scoped=true", function () {
      api.rerender('030671cb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ApparatusDetails/TechnicalSpecs.vue"
export default component.exports